import { PageCard } from "src/common/styles/styles";
import { QuotationForm } from "./QuotationForm";
import { SystemDescriptions } from "src/common/descriptions";
import { QuotationPrintAction, QuotationPrintModal } from "./QuotationPrintModal";
import { useEffect, useState } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/state/reducer";
import { Quotation } from "src/common/models/quotation";
import { useParams } from "react-router-dom";
import { cleanCurrentQuotation, getQuotationByIdApi } from "../state/action";

export const CreateQuotation = () => {
    const dispatch = useDispatch()
    const params = useParams()
    const [isPrintModalOpen, setIsPrintModalOpen] = useState<boolean>(false)
    const descriptions = SystemDescriptions.PAGES.QUOTATION.CREATE
    const currentQuotation: Partial<Quotation> | undefined = useSelector((state: RootState) => state.quotation.currentQuotation)
    const quotationId = params.id ? Number(params.id) : undefined

    useEffect(() => {
        if (quotationId) {
            dispatch(getQuotationByIdApi(quotationId))
        } else {
            dispatch(cleanCurrentQuotation())
        }
    }, [dispatch, quotationId])

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
            style={{ marginBottom: "20px" }}
            extra={
                <Button
                    type="primary"
                    ghost
                    disabled={!currentQuotation?.id}
                    onClick={() => setIsPrintModalOpen(true)}
                >
                    {descriptions.PDF_ACTIONS.TITLE}
                </Button>
            }
        >
            <QuotationForm
            />
            <QuotationPrintModal
                open={isPrintModalOpen}
                action={QuotationPrintAction.PDF}
                onCancel={() => setIsPrintModalOpen(false)}
            />
        </PageCard>
    )
}
